export default __webpack_public_path__ + "static/media/mobile.4c8ec982.jpg";